<template>
  <Header></Header>
  <div class="sm-main-content flex antialiased text-gray-800">
      <div class="sm-main-content-inner">
        <router-view></router-view>
      </div>
  </div>
  
  <Toast />
  <ConfirmDialog></ConfirmDialog>
  <Footer></Footer>
  <NewsletterPopin></NewsletterPopin>
  <AdminToastPendingOperation v-if="isAdmin"></AdminToastPendingOperation>
</template>

<script>
// Import du skin dynamiquement selon VUE_APP_SKIN_NAME
import(`./css/frontend-skin-${process.env.VUE_APP_SKIN_NAME}.scss`);

import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import NewsletterPopin from "./components/NewsletterPopin.vue";
import AdminToastPendingOperation from "./components/admin/AdminToastPendingOperation.vue";
import ConfirmDialog from 'primevue/confirmdialog';
import { useFrontDataStore } from './stores/front'
import { useAdminDataStore } from './stores/admin'
import get from './services/get';
import { storeToRefs } from 'pinia';

export default {
  name: "App",
  components: {
    AdminToastPendingOperation,
    ConfirmDialog,
    Header,    
    Footer,
    NewsletterPopin,
},
  setup() {
    const frontDataStore = useFrontDataStore();
    const adminDataStore = useAdminDataStore();
    if(Object.keys(window.chefCustomerConfig).length == 0) {
      //https://projet-api.miam-vercors.com/api/customergetconfig?domain=projet-simon.miam-vercors.com
      
      if(window.chefCustomerId == 3) {
        // eslint-disable-next-line no-useless-escape
        window.chefCustomerConfig = {"id":3,"name":"Simon","withFront":false,"withTva":true,"withOrder":false,"htmlReplacements":"","headerTitle":"Chef Orga","headerBaseline":"Test simon","facebookPageUrl":"https:\/\/www.facebook.com\/MInottos","instaPageUrl":"https:\/\/www.instagram.com\/ghislainbouilland\/","whatsappJoinLink":""};
      }else{
        // eslint-disable-next-line no-useless-escape
        window.chefCustomerConfig = {"id":1,"name":"miam-vercors","withTva":true,"withFront":true,"withOrder":true,"htmlReplacements":"","headerTitle":"MIAM!","headerBaseline":"Cheffe nomade","facebookPageUrl":"https:\/\/www.facebook.com\/faimdesaison.cheffe.nomade","instaPageUrl":"https:\/\/www.instagram.com\/faimdesaison","whatsappJoinLink":"https:\/\/chat.whatsapp.com\/H4K5JosJ29XEeTtKXiNSWa"};
        var fetchJsonSync = (url) => {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url, false); // false = SYNCHRONE
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.send(null);

          if (xhr.status === 200) {
            return JSON.parse(xhr.responseText);
          } else {
            throw new Error(`Erreur ${xhr.status}: ${xhr.statusText}`);
          }
        }
        const absoluteUrl = process.env.VUE_APP_ABSOLUTE_URL || document.location.origin;
        let customerDomain = absoluteUrl
          .replace(/^https?:\/\//, '')
          .replace(/\/.*/, '');
        if(process.env.VUE_APP_SKIN_NAME == 'faim2s' && process.env.VUE_APP_APIROOTURL == 'https://api.faimdesaison.fr/') {
          customerDomain = 'www.faimdesaison.fr';
        }
        var url = `${process.env.VUE_APP_APIREMOTEROOTURL}api/customergetconfig?domain=${customerDomain}`;
        window.chefCustomerConfig = fetchJsonSync(url);
        console.log('window.chefCustomerConfig', window.chefCustomerConfig);
      }
    }
    
    if(document.location.host.indexOf('localhost') >= 0) {
        
        // Fonction pour vérifier si un paramètre existe (même vide)
        var hasParam = function(name) {
            const urlParams = new URLSearchParams(document.location.search);
            return urlParams.has(name);
        };

        // Fonction pour récupérer la valeur d'un paramètre (même vide)
        var getParam = function(name) {
            // Retourne null si le paramètre n'est pas présent
            const urlParams = new URLSearchParams(document.location.search);
            return urlParams.has(name) ? urlParams.get(name) : null;
        }
        Object.keys(window.chefCustomerConfig).forEach(function(k) {
          if(hasParam('__'+k)) {
            window.chefCustomerConfig[k] = getParam('__'+k);
          }else if(hasParam('_'+k)) {
            window.chefCustomerConfig[k] = getParam('_'+k);
          }
        });
        console.log(window.chefCustomerConfig);
      }

    frontDataStore.setChefCustomerConfig(window.chefCustomerConfig);

    get.getHomeMenus();
    get.listPages();
    
    const authToken = localStorage.getItem('authToken');
    const authTokenGeneratedAtTimestamp = parseInt(localStorage.getItem('authTokenGeneratedAtTimestamp'));
    if(authToken) {
      adminDataStore.setAuthToken(authToken, authTokenGeneratedAtTimestamp);
    }
    const { isAuthenticated: isAdmin } = storeToRefs(adminDataStore);
    return {
      isAdmin,
    };
  },
};

// contenu consigné +0
// emballage jetable + 1

</script>

<style lang="scss">
  @import './css/frontend.scss';
</style>
  